import script from "./option-groups.vue?vue&type=script&setup=true&lang=js"
export * from "./option-groups.vue?vue&type=script&setup=true&lang=js"

import "./option-groups.vue?vue&type=style&index=0&id=ac182572&scoped=true&lang=css"
import "./option-groups.vue?vue&type=style&index=1&id=ac182572&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac182572"]])

export default __exports__